<template>
  <div class="form-group">
    <label>Funding Bill To Address</label>
    <ed-button button-class="btn btn-actionbar" v-if="showEdit" @click="showModal = true">Edit</ed-button>
    <span class="small" v-if="model.Venue"><br />{{ entityName }}</span>
    <span class="small" v-if="model.Address"><br />{{ model.Address }}</span>
    <span class="small" v-if="model.Address2"><br />{{ model.Address2 }}</span>
    <span class="small" v-if="model.CityStateZip"><br />{{ model.CityStateZip }}</span>
    <span class="small" v-if="model.CountryName"><br />{{ model.CountryName }}</span>
    <span class="small" v-if="model.VatNo"><br />VAT ID: {{ model.VatNo }}</span>
    <br />

    <ed-modal :show="showModal" title="Edit Address" @confirm="save" @close="showModal = false">
      <div slot="body">
        <div>
          <ed-input field-label="Entity" required v-model="modelCopy.Venue" />
        </div>
        <div>
          <ed-input field-label="Address" required v-model="modelCopy.Address" />
        </div>
        <div>
          <ed-input field-label="Address 2" v-model="modelCopy.Address2" />
        </div>

        <div>
          <ed-select
            hide-optional
            field-label="Country"
            placeholder="Select a country"
            :options="countries"
            v-model="modelCopy.country"
            label="CountryName"
            track-by="CountryID"
            :openEndpoint='api.$.profile.getAllCountries'
            @select="(o) => { countrySelected(o) }"
            @open="fetchCountriesOnOpen"
            @keyup="fetchCountries"
            @close="restoreCountries"
            name='supplier_country'
          />
        </div>

        <div class="col-md-4 no-pad">
          <ed-input field-label="City" hide-optional v-model="modelCopy.CityName" />
        </div>

        <!-- -->
        <div class="col-md-4">
          <ed-select
            hide-optional
            v-if="isUS()"
            field-label="State"
            placeholder="Select a state"
            :options="USstates"
            v-model="modelCopy.state"
            @open="fetchUSStatesOnOpen"
            @keyup="fetchUSStates"
            @close="restoreUSStates"
            label="StateName"
            track-by="StateID"
            name='us_states'
            @select='(o) => { modelCopy.StateName = o.StateName; modelCopy.StateId = o.StateID }'
          />
          <ed-select
            hide-optional
            v-if="isCanada()"
            field-label="State/Region"
            placeholder="Select a region"
            :options="canadaStates"
            v-model="modelCopy.state"
            @open="fetchCanadaStatesOnOpen"
            @keyup="fetchCanadaStates"
            @close="restoreCanadaStates"
            label="StateName"
            name='canada_states'
            @select='(o) => modelCopy.StateName = o.StateName'
          />
          <ed-input
            hide-optional
            v-if="!modelCopy.CountryName || !isCanada() && !isUS()"
            field-label="State/Region"
            placeholder="Select a region"
            v-model="modelCopy.Region"
            name='state_region'
          />
        </div>

        <div class="col-md-4 no-pad">
          <ed-input field-label="ZIP Code" hide-optional v-model="modelCopy.ZipCode" />
        </div>

        <div>
          <label>VAT: <br />
            <ed-input v-model="modelCopy.VatNo" />
          </label>
        </div>
      </div>
    </ed-modal>
  </div>
</template>

<script>

export default {
  props: {
    model: Object,
    showEdit: Boolean
  },

  data() {
    return {
      showModal: false,
      modelCopy: {
        ...this.model,
        country: { CountryID: 0, CountryName: this.model.CountryName },
        state: { StateID: 0, StateName: this.model.StateOrRegionName },
        Region: this.model.StateOrRegionName
      },
      USstates: [{ StateID: 0, StateName: this.model.StateOrRegionName }],
      USoriginalStates: [],

      canadaStates: [{ StateID: 0, StateName: this.model.StateOrRegionName }],
      originalCanadaStates: [],

      countries: [{ CountryID: 0, CountryName: this.model.CountryName }],
      originalCountries: [],

      counter: 0
    }
  },

  methods: {
    save() {
      this.modelCopy.CityStateZip = `${this.modelCopy.CityName}, ${this.modelCopy.StateName || this.modelCopy.Region}`
      if (this.modelCopy.CityStateZip.trim() === ',') this.modelCopy.CityStateZip = ''
      this.modelCopy.CityStateZip += ' ' + this.modelCopy.ZipCode
      this.$emit('changeAddress', this.modelCopy)
      this.model = this.modelCopy
      this.showModal = false
    },

    fetchCountriesOnOpen() {
      if (this.countries.length && this.countries[0].CountryID !== 0) {
      } else {
        this.api.forms.post(
          this.api.$.profile.getAllCountries,
          {
            q: ''
          }
          ).then(r => {
            if (r && r.data && r.data.Data) {
              this.countries = r.data.Data
              this.originalCountries = r.data.Data
            }
          }
        ).catch(e => console.warn(e))
      }
    },

    fetchCountries(value) {
      this.counter || this.api.forms.post(
        this.api.$.profile.getAllCountries,
        {
          q: value || ''
        }
      ).then(r => {
        this.counter = 0
        if (r && r.data && r.data.Data) {
          this.countries = r.data.Data
        }
      }
      ).catch(e => {
        console.warn(e)
        this.counter = 0
      })
      this.counter = 1
    },

    restoreCountries() {
      if (this.counter === 0) {
        this.countries = utils.copy(this.originalCountries)
      }
    },

    isUS() {
      return this.modelCopy.country.CountryName === 'United States'
    },
    GetStatesUSURL() {
      return this.api.$.profile.getAllStates
    },

    isCanada() {
      return this.modelCopy.country.CountryName === 'Canada'
    },
    GetStatesCanadaURL() {
      return this.api.$.profile.getCanadaStates
    },

    // Fetch States on OPEN
    fetchUSStatesOnOpen() {
      var url = this.GetStatesUSURL()
      this.fetchStatesOnOpen(this.USstates, url)
    },
    fetchCanadaStatesOnOpen() {
      var url = this.GetStatesCanadaURL()
      this.fetchStatesOnOpen(this.canadaStates, url)
    },
    fetchStatesOnOpen(states, url) {
      if (states.length && states[0].StateID !== 0 && (this.isCanada() || this.isUS())) {
      } else {
        this.api.forms.post(
          url,
          {
            q: ''
          }
          ).then(r => {
            if (r && r.data && r.data.Data) {
              this.mapStatesDataOnOpen(r.data.Data)
            }
          }
        ).catch(e => console.warn(e))
      }
    },
    mapStatesDataOnOpen(data) {
      if (this.isUS()) {
        this.USstates = this.USoriginalStates = data
      } else {
        this.canadaStates = this.originalCanadaStates = data
      }
    },

    // Fetch States on search text
    fetchUSStates(value) {
      var url = this.GetStatesUSURL()
      this.fetchStates(value, url)
    },
    fetchCanadaStates(value) {
      var url = this.GetStatesCanadaURL()
      this.fetchStates(value, url)
    },
    fetchStates(value, url) {
      this.counter || this.api.forms.post(
        url,
        {
          q: value || ''
        }
      ).then(r => {
        this.counter = 0
        if (r && r.data && r.data.Data) {
          this.mapStatesDataOnFetch(r.data.Data)
        }
      }
      ).catch(e => {
        console.warn(e)
        this.counter = 0
      })
      this.counter = 1
    },
    mapStatesDataOnFetch(data) {
      if (this.isUS()) {
        this.USstates = data
      } else {
        this.canadaStates = data
      }
    },

    // Restore States
    restoreUSStates() {
      this.restoreStates(this.USstates, this.USoriginalStates)
    },
    restoreCanadaStates() {
      this.restoreStates(this.canadaStates, this.originalCanadaStates)
    },
    restoreStates(states, originalStates) {
      if (this.counter === 0) {
        this.states = utils.copy(originalStates)
      }
    },

    countrySelected(e) {
      this.resetState(e.CountryName)
      this.modelCopy.CountryName = e.CountryName
      this.modelCopy.CountryID = e.CountryID
    },

    resetState(countryName) {
      if (this.originalCountryName !== '' && this.originalCountryName !== countryName) {
        this.modelCopy.StateId = 0
        this.modelCopy.StateName = ''
        this.modelCopy.Region = ''
      } else {
        this.originalCountryName = countryName
      }
    }
  },

  computed: {
    entityName() {
      return this.model.Venue.replace('_', '')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/_modules/Payment/components/FundingAddress.vue